import { MdOutlineStorefront } from 'react-icons/md';
import { Hidden } from '@material-ui/core';

import { Button } from '@components/Button';

import { Container, Title, Text, ButtonContainer } from './styles';

const isAndroid =
  /Android/i.test(navigator.userAgent) &&
  'https://play.google.com/store/apps/details?id=app.somalabs.somabox&pcampaignid=web_share';
const isIOS =
  /iPhone|iPad|iPod/i.test(navigator.userAgent) &&
  'https://apps.apple.com/br/app/somabox/id1636403657';

const SiteClosedOverlayer = () => {
  const storeUrl = isAndroid || isIOS;

  return (
    <Container>
      <div className="iconImage">
        <p>
          <MdOutlineStorefront />
        </p>
      </div>
      <Title>OBRIGADO PELO SEU TEMPO COM O STORE!</Title>
      <Text>
        <strong>O SomaStore </strong>
        foi
        <strong> desligado </strong>
        no dia 30/05/2025.
      </Text>
      <Text>
        Agora vocês possuem o <strong>Box </strong>
        <br />
        para continuar acompanhando e realizando seus atendimentos!
      </Text>
      <ButtonContainer>
        <Hidden mdDown>
          <Button href="https://somabox.somalabs.com.br/">
            <p>IR PARA O BOX</p>
          </Button>
        </Hidden>
        <Hidden mdUp>
          <Button href="https://somabox.somalabs.com.br/">
            <p>IR PARA O BOX (GERENTE)</p>
          </Button>
          <br />
          <Button href={storeUrl}>
            <p>IR PARA O BOX (VENDEDOR)</p>
          </Button>
        </Hidden>
      </ButtonContainer>
    </Container>
  );
};

export { SiteClosedOverlayer };
